/*
  Event Override Layer
*/
export const eventOverrideSourceId = 'event-override-overlay'
export const eventOverrideLayerId = 'event-override-transparent-fill'

/*
  Site Polygons
*/
export const sitePolygonsSourceId = 'site-polygons'
export const sitePolygonFillsLayerId = 'site-fills'
export const sitePolygonOutlinesLayerId = 'site-outlines'

/*
  SelectedSite
*/
export const selectedSiteExternalSourceId = 'site-external-polygon'
export const selectedSiteExternalLayerId = 'site-external-fill'
export const selectedSiteExternalFeatureId = 'site-external-feature'

export const selectedSiteSourceId = 'selected-site-polygon'
export const selectedSiteFillLayerId = 'selected-site-fill'
export const selectedSiteOutlineLayerId = 'selected-site-outline'
export const selectedSiteOutlineClickId = 'selected-site-outline-click'

export const storySiteLayerIdPrefix = 'story-'

export const footprintsSourceId = 'remedy-footprints'
export const footprintsLayerId = 'footprint-fills'

/*
  Parcel Select
*/
// Bottom-most parcel select layer; data layers render below it
export const parcelSelectDataLayerKey = 'parcel-select'
export const parcelSelectLayerValueKey = 'parcel-select-lv'
export const parcelSelectFillLayerId = `${parcelSelectDataLayerKey}.${parcelSelectLayerValueKey}.fill`
export const getParcelSelectSourceId = (tilesetUrl: string) =>
  `${parcelSelectDataLayerKey}:${tilesetUrl}`

/*
  Lists
*/
// ordered bottom -> top
export const sketchLayerIdsInOrder = [
  sitePolygonFillsLayerId,
  sitePolygonOutlinesLayerId,
  selectedSiteExternalLayerId,
  selectedSiteOutlineLayerId,
  selectedSiteOutlineClickId,
  footprintsLayerId,
  selectedSiteFillLayerId
]

export const allSketchLayerIds = [
  ...sketchLayerIdsInOrder,
  ...sketchLayerIdsInOrder.map((id) => `${storySiteLayerIdPrefix}${id}`)
]
